import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { StyleSheet, Text, View, ImageBackground } from 'react-native';
import CloudyWeather from './cloudy_weather';
import ClearWeather from './clear_weather';
import RainyWeather from './rainy_weather';
import ThunderstormWeather from './thunderstorm_weather';
import DrizzleWeather from './drizzle_weather';
import HazeWeather from './haze_weather';
import ElseWeather from './else_weather';
import Loader from './loader';
import { weather } from './actions/weather_data';  // Changing weather action Redux

import { changeCity } from './actions/change_city';  // Changing weather action Redux

import { useSelector, useDispatch } from 'react-redux';  // Hooks Redux

export default function Weather({ weather_data }) {
    const REACT_APP_API_URL = 'https://api.openweathermap.org/data/2.5';
    const REACT_APP_API_KEY = '5d361ddf57410aae46781a0990a8d7f6';
    const REACT_APP_ICON_URL = 'https://openweathermap.org/img/w';
    const [state, setState] = React.useState({});
    var data_store_counter = 0;
    var w_data = useSelector(state => state.weather);

    const dispatch = useDispatch();
    const fetchLocation = async () => {
        await fetch("https://geolocation-db.com/json/")
            .then(res => res.json())
            .then(result => {
                //console.log(result.city);
                dispatch(changeCity(result.city));
                fetchWeatherByCity(result.city);
            });
    }
    const fetchWeatherByCity = async (city) => {
        /*navigator.geolocation.getCurrentPosition(function (position) {
            setLat(position.coords.latitude);
            setLong(position.coords.longitude);
        });*/
        await fetch(`${REACT_APP_API_URL}/weather/?q=${city}&units=metric&APPID=${REACT_APP_API_KEY}`)
            .then(res => res.json())
            .then(result => {

                //setData(result);

                //console.log(result);
                //console.log("Data stored");
                dispatch(weather(result));
                setState({});
                //data_store_counter +=1;

                //console.log(data_store_counter);
            });
    };
    React.useEffect(() => {

        fetchLocation();

    }, [dispatch]);


    //console.log(weather_data.main);
    //console.log("Dadsaaa");
    return (


        <ImageBackground source={{uri: "https://firebasestorage.googleapis.com/v0/b/imagehosting-cb259.appspot.com/o/else_weather.png?alt=media&token=11ba840d-2c42-45f2-97f2-d1b0e2a446a1"}} style={{ width: "100%", height: "100%", resizeMode: "contain" }}>
            {(typeof w_data.main !== 'undefined') ? (
                () => {
                    //console.log("Data Received");
                    if (w_data.weather[0].main === 'Clouds') {
                        return (
                            <CloudyWeather />
                        );
                    }
                    else if (w_data.weather[0].main === 'Clear') {
                        return (
                            <ClearWeather />
                        );
                    }
                    else if (w_data.weather[0].main === 'Rain') {
                        return (
                            <RainyWeather />
                        );
                    }
                    else if (w_data.weather[0].main === 'Thunderstorm') {
                        return (
                            <ThunderstormWeather />
                        );
                    }
                    else if (w_data.weather[0].main === 'Drizzle') {
                        return (
                            <DrizzleWeather />
                        );
                    }
                    else if (w_data.weather[0].main === 'Haze') {
                        return (
                            <HazeWeather />
                        );
                    }
                    else {
                        return (
                            <ElseWeather weather_data={w_data} />
                        );
                    }
                }
            )() : (
                <Loader />
            )
            }

        </ImageBackground >
    )
}



const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
